type SetFieldValueFn = (field: string, value: any) => void;

export const copyAddressFields = (
  setFieldValue: SetFieldValueFn,
  targetKey: string,
  source?: Record<string, any>,
) => {
  if (!source) return;

  const fields = [
    'addressDetails',
    'city',
    'postCode',
    'stateId',
    'timeZoneId',
  ];

  fields.forEach((field) => {
    setFieldValue(`${targetKey}.${field}`, source[field]);
  });
};
